module.exports = __webpack_public_path__ + "static/media/map_icon.4e17c1b1.svg";